import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function LoginPage({ setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/assets/css/vLogin.css";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE}/api/login`, {
        username,
        password,
      });
      localStorage.setItem("token", res.data.token);
      if (res.data?.user) {
        localStorage.setItem("first", JSON.stringify(res.data.user));
      } else {
        localStorage.removeItem("first");
      }
      const unreadNotices = Array.isArray(res.data?.unread_notices)
        ? res.data.unread_notices
        : [];
      localStorage.setItem("unreadNotice", JSON.stringify(unreadNotices));
      setIsLoggedIn(true);
      navigate("/");
    } catch (err) {
      const data = err.response?.data;
      let msg = "";

      if (typeof data === "string") {
        const text = data.trim();
        try {
          msg = JSON.parse(text)?.message || "";
        } catch {
          msg = "";
        }
        if (!msg && text && !text.startsWith("<")) msg = text;
      } else if (data && typeof data === "object") {
        msg = data.message || data.msg || "";
      }

      alert(msg || "서버와의 통신에 실패했습니다.");
    }
  };

  return (
    <div className="nk-app-root">
      <div className="nk-main member_login">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <div className="nk-split nk-split-page nk-split-lg">
              <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                  <a href="#" className="toggle btn-white btn btn-icon btn-light">
                    <em className="icon ni ni-info"></em>
                  </a>
                </div>
                <div className="nk-block nk-block-middle nk-auth-body">
                  <div className="brand-logo">
                    <a href="#" className="logo-link">
                      <img
                        className="logo-light logo-img"
                        src="./images/logo_matrix.png"
                        alt="logo"
                      />
                      <img
                        className="logo-dark logo-img logo-img-lg"
                        src="./images/logo_matrix-dark.png"
                        alt="logo-dark"
                      />
                    </a>
                  </div>
                  <div className="nk-block-head">
                    <div className="nk-block-head-content">
                      <div className="nk-block-des" style={{fontSize:0}}>
                        <p>아이디와 비밀번호를 입력해주세요.</p>
                      </div>
                    </div>
                  </div>
                  <form onSubmit={handleLogin} className="form-validate is-alter">
                    <div className="form-group">
                      <label className="form-label" htmlFor="user-id">아이디</label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="user-id"
                          required
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="아이디"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="password">비밀번호</label>
                      <div className="form-control-wrap">
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          id="password"
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="비밀번호"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <button className="btn btn-lg btn-primary btn-block" type="submit">
                        Sign in
                      </button>
                    </div>
                  </form>
                </div>
                <div className="nk-block nk-auth-footer">
                  <div className="text-center">
                    <p>&copy; 2025 <b>Eclipse</b></p>
                  </div>
                </div>
              </div>
              <div className="nk-split-content bg-photo nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right">
                <div className="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                  <div className="nk-feature nk-feature-center">
                    <div className="nk-feature-content py-4 p-sm-5">
                      <h4>Gaming API Integration</h4>
                      <p>
                        B2B 통합 API 솔루션을 사용하시면 세계 최고의 라이브게임을 안전하고 빠른 속도로 운영하실 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
